import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const VoucherModal = ({ open, onClose, pdfUrl, requestId, paymentCode }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Voucher View
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {pdfUrl ? (
          <Box sx={{ height: "80vh" }}>
            <iframe
              src={pdfUrl}
              title="Payment Voucher"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          </Box>
        ) : (
          <Typography>No voucher available.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VoucherModal;
